import { colorType } from "lib/interfaces"
import Text from "../Text"

type BreadcrumbsItemProps = {
  label: string
  href?: string
  color?: colorType
  weight?: "bold" | "semibold" | "normal"
}

type formatHtml = "slash" | "greater"
interface ShowFormatProps {
  format: formatHtml
  color?: colorType
}

export interface BreadcrumbsProps {
  breadcrumbsData: BreadcrumbsItemProps[]
  size: "large" | "small"
  gutterBottom?: boolean
  color?: colorType
  format?: formatHtml
}

function ShowFormat({ format, color }: ShowFormatProps) {
  if (format === "greater") {
    return (
      <Text color={color} weight="bold">
        &lt;
      </Text>
    )
  }

  return (
    <Text color={color} weight="bold">
      /
    </Text>
  )
}
function Breadcrumbs({
  breadcrumbsData,
  color = "breadcrumbs",
  size,
  gutterBottom,
  format = "greater",
}: BreadcrumbsProps) {
  const breadcrumbsUi = (breadcrumbs, index) => {
    const lastIndex = index + 1 === breadcrumbsData.length

    if (size === "large") {
      return (
        <div key={`'breadcrumbs + ${index + 1}`} className="flex items-end">
          <a href={breadcrumbs.href}>
            <Text color={breadcrumbs.color  || "primary"} weight="bold">
              {breadcrumbs.label.toLocaleUpperCase()}
            </Text>
          </a>
          {!lastIndex && (
            <div className="px-4">
              <ShowFormat format={format} color={color} />
            </div>
          )}
        </div>
      )
    }
    return (
      <div
        key={`'breadcrumbs + ${index + 1}`}
        className={`flex items-end ${gutterBottom ? "mb-4" : ""}`}
      >
        <a href={breadcrumbs.href}>
          <Text color={breadcrumbs.color || "primary"} weight={breadcrumbs.weight}>{breadcrumbs.label}</Text>
        </a>
        {!lastIndex && (
          <div className="px-4">
            <ShowFormat format={format} color={color} />
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="flex flex-wrap">
      {breadcrumbsData.map((value, index) => breadcrumbsUi(value, index))}
    </div>
  )
}

export default Breadcrumbs
